import type { AnswersIds } from "@/Modules/Models/Domain/OnBoarding";
import type { UpdateReassignUserApiQuery } from "@/Modules/Models/Api/OnBoarding";

import { updateReassignUser } from "@/Services/TherapyApi/OnBoardingFunctional";

import useUserStore from "@/Modules/User/Store";
import useOnboardingStore from "@/Modules/OnBoarding/Store";

import { hasValue } from "@/Utils/Objects";
import { danger } from "@/Utils/Debug";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";

async function updateReassignUserAH(): Promise<void> {
  const userStore = useUserStore();
  const onBoardingStore = useOnboardingStore();
  const onBoardingData = onBoardingStore.answers;
  const apiQuery = transformDataToApiQuery(onBoardingData);

  onBoardingStore.hasErrorInProcess = false;
  onBoardingStore.errorCode = null;
  onBoardingStore.isLoading = true;

  try {
    if (hasValue(userStore.user)) {
      const uuid = userStore.user.id;

      await updateReassignUser(apiQuery, uuid);
      onBoardingStore.isUpdateRegister = true;
    }

    onBoardingStore.setNextStep(null);

    await userStore.setUser();
  } catch (err: unknown) {
    const code = isApiError(err) ? err["error_code"] : null;

    danger(code);

    onBoardingStore.hasErrorInProcess = true;
  } finally {
    onBoardingStore.isLoading = false;
  }
}

function transformDataToApiQuery(
  onBoardingData: Partial<Record<AnswersIds, string>>
): UpdateReassignUserApiQuery {
  return {
    reassign_reason: onBoardingData.reassign_reason ? onBoardingData.reassign_reason : "",
    details_reassign: onBoardingData.details_reassign,
    patient_subarea: onBoardingData.sub_area,
    tell_me_more: onBoardingData.tell_me_more,
    gender_preference: onBoardingData.therapist_gender_preferences,
    availability: onBoardingData.therapist_availability,
    therapist_name: onBoardingData.therapist_name,
    zone: onBoardingData.zone,
    privacy_policy_at: parseInt(onBoardingData.privacy_policy_at!),
  };
}

export default updateReassignUserAH;
